import { render } from "./AddToList.vue?vue&type=template&id=36f52d57&scoped=true"
import script from "./AddToList.vue?vue&type=script&lang=js"
export * from "./AddToList.vue?vue&type=script&lang=js"

import "./AddToList.vue?vue&type=style&index=0&id=36f52d57&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f52d57"]])

export default __exports__